import { Adapter as i } from "../../../../adapter.js";
import { StripeReaderConfigurationModel as t } from "./stripeReaderConfiguration.model.js";
class m extends i {
  adapt(e) {
    var r;
    return new t({
      locationId: e.location_id,
      devices: ((r = e.devices) == null ? void 0 : r.map((o) => ({
        id: o.id,
        name: o.name
      }))) ?? []
    });
  }
  serialize(e) {
    throw new Error("Method not implemented.");
  }
}
export {
  m as StripeReaderConfigurationAdapter
};
//# sourceMappingURL=stripeReaderConfiguration.adapter.js.map
